module.exports = __webpack_public_path__ + "static/img/recepit_bkg.124dfca0.png";